import { Paper } from '@mui/material';
import theme from 'library/theme/theme';
import styled from 'styled-components';

export const FormContent = styled(Paper).attrs({ variant: 'outlined' })`
  padding: ${theme.spacing(3)};
`;
